import { useEffect, RefObject } from 'react';

import { slider } from '../utils/slider';

/**
 * A React hook that enables a slider effect on a DOM element.
 * The slider effect allows the element to be scrolled by clicking and dragging the mouse.
 *
 * @param {React.RefObject} tagListRef - A ref object pointing to the DOM element to apply the slider effect to.
 *
 * @example
 * const tagListRef = useRef(null);
 * useSlider(tagListRef);
 */
export const useSlider = (tagListRef: RefObject<HTMLElement>) => {
  useEffect(() => {
    const unsubscribe = tagListRef.current ? slider(tagListRef.current) : () => {};
    return unsubscribe;
  }, []);
};
